// import amplitude from 'amplitude-js';

const { mixpanel } = window;

const live = process.env.NODE_ENV === 'production';
// if (amplitude) {
// 	// AMPLITUDE_API_KEY: JSON.stringify('e662e19f861741aaf27a8326b8ca327c'),
// 	amplitude.init(process.env.AMPLITUDE_API_KEY);
// }
export const identify = (key) => {
	// console.log('mixpanel ', mixpanel);
	if (live && mixpanel) {
		// console.log('identify');
		mixpanel.time_event(key);
	}
};

export const optInTracking = (options) => {
	if (live && mixpanel) {
		mixpanel.opt_in_tracking(options);
	}
};

export const optOutTracking = (options) => {
	if (live && mixpanel) {
		mixpanel.opt_out_tracking(options);
	}
};

export const reset = () => {
	if (live && mixpanel) {
		mixpanel.reset();
	}
	// if (live && amplitude) {
	// 	amplitude.getInstance().setUserId(null); // not string 'null'
	// 	amplitude.getInstance().regenerateDeviceId();
	// }
};
export const alias = (name) => {
	if (live && mixpanel) {
		mixpanel.alias(name);
	}
};
export const trackLink = (selector, name) => {
	if (live && mixpanel) {
		mixpanel.track_links(selector, name);
	}
};
export const timeEvent = (key, data) => {
	if (live && mixpanel) {
		// console.log('timeEvent ' + key);
		mixpanel.time_event(key, data);
	}
};
export const track = (name, data) => {
	if (live && mixpanel) {
		console.log('gmtrack mixpanel', name, data);
		// console.log('track event (mixpanel)', name);
		mixpanel.track(name, data);
		mixpanel.people.set({
			'Last Activity': new Date(),
		});
	} else {
		// console.log(`Track ${name}`);
	}
	// console.log('track', name, data);
	// if (live && amplitude) {
	// 	// console.log('track event (amplitude)', name);
	// 	amplitude.getInstance().logEvent(name, data);
	// }
};

export const register = (data) => {
	if (live && mixpanel) {
		// console.log('register');
		mixpanel.register(data);
	} else {
		// console.log(`Register`);
	}
};
export const setUser = (data) => {
	console.log('GM Agent Admin Set User');
	if (live && mixpanel) {
		// console.log('Set User Data: ', data);
		mixpanel.identify(data.email);
		mixpanel.people.set({
			$email: data.email,
			'Date Joined': data.date_joined,
			appCountry: data.country,
			$created: data.date_joined,
			$name: `${data.first_name} ${data.last_name}`,
			$first_name: data.first_name,
			$last_name: data.last_name,
			Admin: data.is_staff,
			userId: data.id,
			Company: data.firm_name,
		});
		mixpanel.register({
			userId: data.id,
		});
	} else {
		// console.log(`Set user`);
	}
	// if (live && amplitude) {
	// 	amplitude.getInstance().setUserId(data.email);
	// 	const userProperties = {
	// 		email: data.email,
	// 		appCountry: data.country,
	// 		dateJoined: data.date_joined,
	// 		created: data.date_joined,
	// 		name: `${data.first_name} ${data.last_name}`,
	// 		first_name: data.first_name,
	// 		last_name: data.last_name,
	// 		admin: data.is_staff,
	// 		userId: data.id,
	// 		company: data.firm_name
	// 	};
	// 	amplitude.getInstance().setUserProperties(userProperties);
	// }
};
window.gm_reset = reset;
window.gm_alias = alias;
window.gm_identify = identify;
window.gm_setUser = setUser;
window.gm_track = track;
window.gm_timeEvent = timeEvent;
window.gm_register = register;
window.gm_trackLink = trackLink;
window.gm_optInTracking = optInTracking;
window.gm_optOutTracking = optOutTracking;
